import { SHAPE_STROKE_PROPS } from './stroke-props';

interface CylinderProps {
  strokeDasharray: string | undefined;
}

export default function Cylinder({ strokeDasharray }: CylinderProps) {
  return (
    <>
      <rect x="0" y="12" width="100" height="76" strokeDasharray={strokeDasharray} {...SHAPE_STROKE_PROPS} />
      <ellipse cx="50" cy="12" rx="50" ry="12" strokeDasharray={strokeDasharray} {...SHAPE_STROKE_PROPS} />
      <ellipse cx="50" cy="88" rx="50" ry="12" strokeDasharray={strokeDasharray} {...SHAPE_STROKE_PROPS} />
    </>
  );
}
